// Author thq
// Date 2021-11-02 15:55:05

class EmSppUnitSpu {
constructor({
        id = null,
        sid = '',
        code = '',
        name = '',
        spuBitnumber = '',
        spuBasecodeflag = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sid = sid;
    this.code = code;
    this.name = name;
    this.spuBitnumber = spuBitnumber;
    this.spuBasecodeflag = spuBasecodeflag;
    this.remark = remark;
}
}

function newEntity() {
return new EmSppUnitSpu();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppUnitSpu.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sid',
        label: 'label.em.spareparts.emSppUnitSpu.grid.sid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppUnitSpu.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppUnitSpu.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spuBitnumber',
        label: 'label.em.spareparts.emSppUnitSpu.grid.spuBitnumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spuBasecodeflag',
        label: 'label.em.spareparts.emSppUnitSpu.grid.spuBasecodeflag',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppUnitSpu.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sidFilter : '',
    codeFilter : '',
    nameFilter : '',
    spuBitnumberFilter : '',
    spuBasecodeflagFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sidFilter',
        label: 'label.em.spareparts.emSppUnitSpu.filter.sid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.spareparts.emSppUnitSpu.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppUnitSpu.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spuBasecodeflagFilter',
        label: 'label.em.spareparts.emSppUnitSpu.filter.spuBasecodeflag',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.spareparts.emSppUnitSpu.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppUnitSpu.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppUnitSpu.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spuBitnumber',
        label: 'label.em.spareparts.emSppUnitSpu.entity.spuBitnumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'spuBasecodeflag',
        label: 'label.em.spareparts.emSppUnitSpu.entity.spuBasecodeflag',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppUnitSpu.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppUnitSpu, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
